"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Background = _interopRequireDefault(require("./Background"));
var _reactIntl = require("react-intl");
var _utils = require("../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var TextCell = /*#__PURE__*/function (_react$default$Compon) {
  function TextCell() {
    var _this3;
    _classCallCheck(this, TextCell);
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this3 = _callSuper(this, TextCell, [].concat(args));
    _this = _this3;
    _defineProperty(_this3, "state", {});
    _defineProperty(_this3, "preloadComponent", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!_this.state.htmlData) {
              _context.n = 1;
              break;
            }
            return _context.a(2, true);
          case 1:
            return _context.a(2, _this.recomputeHtmlData());
        }
      }, _callee);
    })));
    return _this3;
  }
  _inherits(TextCell, _react$default$Compon);
  return _createClass(TextCell, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.preloadComponent();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return (0, _utils.shouldCellComponentUpdate)(this.props, nextProps) || this.state !== nextState;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (!prevProps.intl && !!this.props.intl || !!prevProps.intl && prevProps.intl.locale !== this.props.intl.locale) {
        this.recomputeHtmlData();
      }
    }
  }, {
    key: "recomputeHtmlData",
    value: function recomputeHtmlData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2$props, defaultLanguage, cell, intl, htmlData, textData;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2$props = _this2.props, defaultLanguage = _this2$props.defaultLanguage, cell = _this2$props.cell, intl = _this2$props.intl;
              htmlData = (0, _utils.i18nData)(cell, 'html_txt', intl, defaultLanguage);
              if (!htmlData) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, new Promise(function (resolve, reject) {
                _this2.setState({
                  htmlData: htmlData
                }, function () {
                  resolve(true);
                });
              }));
            case 1:
              textData = (0, _utils.i18nData)(cell, 'text_data', intl, defaultLanguage);
              if (textData) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, true);
            case 2:
              return _context2.a(2, new Promise(function (resolve, reject) {
                console.log("Generating HTML text data...");
                _this2.setState({
                  htmlData: (0, _utils.htmlTextData)(textData)
                }, function () {
                  resolve(true);
                });
              }));
          }
        }, _callee2);
      }))();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        defaultLanguage = _this$props.defaultLanguage,
        cell = _this$props.cell,
        uriTransformer = _this$props.uriTransformer;
      var htmlData = this.state.htmlData;
      if (!htmlData) return null;
      var style = _objectSpread(_objectSpread(_objectSpread({}, this.props.style), {}, {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        position: 'absolute',
        lineHeight: "".concat(cell.line_height, "em"),
        letterSpacing: "".concat(cell.letter_spacing, "em"),
        display: 'flex',
        flexDirection: 'column'
      }, TextCell.flexHorizontalAlign(cell.horizontal_align)), TextCell.flexVerticalAlign(cell.vertical_align));
      return /*#__PURE__*/_react.default.createElement(_Background.default, {
        value: cell,
        uriTransformer: uriTransformer,
        defaultLanguage: defaultLanguage
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: style,
        dangerouslySetInnerHTML: {
          __html: htmlData
        }
      }));
    }
  }]);
}(_react.default.Component);
_defineProperty(TextCell, "whyDidYouRender", true);
_defineProperty(TextCell, "flexVerticalAlign", function (cellVerticalAlign) {
  switch (cellVerticalAlign) {
    case 'top':
      return {
        justifyContent: 'flex-start'
      };
    case 'bottom':
      return {
        justifyContent: 'flex-end'
      };
    case 'middle':
      return {
        justifyContent: 'center'
      };
    default:
      return {};
  }
});
_defineProperty(TextCell, "flexHorizontalAlign", function (cellHorizontalAlign) {
  switch (cellHorizontalAlign) {
    case 'left':
      return {
        alignContent: 'flex-start',
        textAlign: 'left'
      };
    case 'right':
      return {
        alignContent: 'flex-end',
        textAlign: 'right'
      };
    case 'center':
      return {
        alignContent: 'center',
        textAlign: 'center'
      };
    case 'justify':
      return {
        alignContent: 'flex-start',
        textAlign: 'justify'
      };
    default:
      return {};
  }
});
var _default = exports.default = (0, _reactIntl.injectIntl)(TextCell);